import React from "react"
import { useParams } from "react-router-dom";
import { Badge, Box, CardBody, CardHeader, Divider, VStack } from "@chakra-ui/react";
import { SettingItem } from "../../organisms/SettingItem";
import { useFetchSoCouponSettingByRestaurantId } from "../../../hooks/socoupon/useFetchSoCouponSettingByRestaurantId";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { RestaurantSettingCardFooter } from "../../organisms/restaurant/RestaurantSettingCardFooter";


export const SoCouponSetting = () => {
  const { restaurantId } = useParams();
  const {soCouponSetting, isLoading} = useFetchSoCouponSettingByRestaurantId(restaurantId);
  if (isLoading) return <CircularLoading />;
  const path = soCouponSetting ? `${soCouponSetting?.id}/edit` : `register`;
  const settingItems = [
    {label: 'ブランチスコア', content: soCouponSetting?.branch_score ?? '未登録'},
    {label: '遷移先URL', content: soCouponSetting?.g_url ?? '未登録'},
    {
      label: 'リマインド',
      content: (
        <Badge colorScheme={soCouponSetting?.remind ? 'green' : 'gray'}>
          {soCouponSetting?.remind ? 'ON' : 'OFF'}
        </Badge>
      ),
    },
  ];
  return (
    <DarkShadowCard w='100%'>
      <CardHeader pb={0}>
        <CardHeading icon={<SettingsIcon />} heading='即ーポン設定'/>
      </CardHeader>
      <CardBody>
        <VStack align='start' fontSize='sm' fontWeight='bold' spacing={4} w='100%'>
          <Divider my={0} />
          {settingItems.map((detail) => (
            <React.Fragment key={detail.label}>
              <Box w='100%'>
                <SettingItem label={detail.label} content={detail.content}/>
              </Box>
              <Divider my={0} />
            </React.Fragment>
          ))}
        </VStack>
      </CardBody>
      <RestaurantSettingCardFooter path={path} />
    </DarkShadowCard>
  );
};